export const OTP_VERIFY_URL= 'apifabric/auth/otp/verify/';
export const WHATS_OTP_VERIFY_URL='apifabric/whatsapp/update-number';
export const SEND_OTP_FOR_WHATSAPP='apifabric/whatsapp/otp/send'